import { render, staticRenderFns } from "./buttonSpinner.vue?vue&type=template&id=0bc8f673&scoped=true&"
import script from "./buttonSpinner.vue?vue&type=script&lang=js&"
export * from "./buttonSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc8f673",
  null
  
)

export default component.exports